import _ = require('underscore');

import { Messages } from '../../../../codegen/Localize';
import { ISubscriptionInfo } from '../../../../ts/models/ISubscriptionInfo';
import { changeSubscriptionsFormat } from '../../../actions/spaces/SubscriptionsActions';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isAnyItemFlowSubscription } from './IEntityActionHelpers';

export const ChangeSubscriptionsFormatEntityAction: IEntityAction<ISubscriptionInfo, {}> = {
  name: EntityActionNames.SubscriptionChangeFormat,
  translateName: Messages.changeSubscriptionsFormat_action,
  isVisible: (subscriptions) => !isAnyItemFlowSubscription(subscriptions),
  isClickable: (availableActions: {}, subscriptions: ISubscriptionInfo[]) => {
    return _.any(subscriptions, (subscription) => subscription.canManageSubscription);
  },
  createReduxAction: (subscriptions: ISubscriptionInfo[]) => changeSubscriptionsFormat(subscriptions)
};
